import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "../../../Containers/ContainerCreate";
import { getChimneyProfile } from "../../../api/getChimneyProfile";
import { Redirect } from "react-router-dom";

class ChimneyProfileContainer extends React.Component {
  componentDidMount() {
    const { chimDir } = this.props;
    this.props.request(chimDir);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chimDir !== this.props.chimDir) {
      this.props.request(this.props.chimDir);
    }
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const profile = (data && data.data) || {};
    const error = (data && data.data.result === "error") || false;
    if (error) {
      return <Redirect to={`/`} />;
    }
    return render({ profile, loading, failure });
  };
}

ChimneyProfileContainer.propTypes = {
  chimDir: PropTypes.string.isRequired,
};

export default CreateContainer(getChimneyProfile, ChimneyProfileContainer);
